import { FC, memo } from 'react';

import { ESelectorCy } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useToast } from '@core/hook';
import { EFontWeight, EIcon, ESize, EColor } from '@core/type';

import { ButtonIcon } from '../button/ButtonIcon';
import { Icon } from '../icon/Icon';
import { Box } from '../layout/Box';
import { Typography } from '../typography/Typography';
import { ToastBase } from './ToastBase';
import { ToastProps } from './interface-toast';

export const Toast: FC<ToastProps> = memo(
  ({ clearId, id, status, title, withoutLogo, description, placement, timeout: delay }) => {
    const { isPhone } = useContextMediaQuery();
    const { isVisible, clearToast, onAnimationEnd } = useToast({
      delay,
      clearId,
      id,
    });

    return (
      <ToastBase
        data-cy={ESelectorCy.TOAST}
        placement={placement}
        isVisible={isVisible}
        onAnimationEnd={onAnimationEnd}
      >
        <Box
          position={'relative'}
          padding={'24px 64px 24px 24px'}
          display={'flex'}
          borderWidth={'1px'}
          borderStyle={'solid'}
          borderRadius={'8px'}
          backgroundColor={{ semanticType: status, variant: EColor.LIGHT }}
          borderColor={status}
          boxShadow={EColor.ELEVATION_2}
        >
          <Box position={'absolute'} top={'24px'} right={'24px'}>
            <ButtonIcon
              onClick={clearToast}
              iconProps={{ type: EIcon.CROSS, size: ESize.SM, color: status }}
            />
          </Box>
          {!withoutLogo && !isPhone && (
            <Box flexShrink={0} marginRight={24}>
              <Icon type={EIcon.GA_LOGO} size={ESize.LG} color={status} />
            </Box>
          )}
          <Box>
            <Box marginBottom={4}>
              <Typography color={status} fontWeight={EFontWeight.BOLD}>
                {title}
              </Typography>
            </Box>
            <Box>
              <Typography color={status}>{description}</Typography>
            </Box>
          </Box>
        </Box>
      </ToastBase>
    );
  },
);

Toast.displayName = 'Toast';
